import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, CardBody, Col, Row } from 'reactstrap'
import { apiGet, apiPost2 } from '../../api'
import { empresa } from '../../constants'
import { urlConsultarIdentificacion, urlGuardarPersonas, urlObtenerExcel, urlRecuperarCarritoAccP } from '../../constants/urls'
import ContainerApAbierto from '../CotizacionAccidentePersonalAbierto/ContainerApAbierto'
import Valores from '../CotizacionAccidentePersonalAbierto/Valores'
import ComponentCargaMasiva from './ComponentCargaMasiva'
import ComponentOpciones from './ComponentOpciones'
import ComponentPersonas from './ComponentPersonas'
import ComponentTipoCarga from './ComponentTipoCarga'
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Formulario from '../Generales/Formulario'

const ContainerCargaVidas = (props) => {

    const [value, setValue] = useState('masiva');
    const [carritoActual, setCarritoActual] = useState(null)
    const [totales, setTotales] = useState(null)
    const [productos, setProductos] = useState([])
    const [productoSeleccionado, setProductoSeleccionado] = useState(null)
    const [loading, setLoading] = useState(false)
    const [errorGlobal, setErrorGlobal] = useState('')
    const [mostrarErrores, setMostrarErrores] = useState(false)
    const [urlPdf, setUrlPdf] = useState(null)
    const [calcular, setCalcular] = useState(false)
    const [values, setValues] = useState({})
    const [valuesAux, setValuesAux] = useState({})
    const [personaDuplicada, setPersonaDuplicada] = useState(false)
    const [personaDuplicadaMasivo, setPersonaDuplicadaMasivo] = useState(false)
    const [idDuplicadaMasivo, setIdDuplicadaMasivo] = useState('')
    const [plantillaConError, setPlantillaConError] = useState(false)
    const [indexProducto, setIndexProducto] = useState(0)
    const [ titulo, setTitulo ] = useState('')
    const [tituloPrimaNeta, setTituloPrimaNeta] = useState(null);
    const [tituloPrimaTotal, setTituloPrimaTotal] = useState(null);

    const [personas, setPersonas] = useState([])
    const [columnas, setColumnas] = useState([])
    const [carDescripcionSeguro, setCarDescripcionSeguro]= useState('')

    const [datosPlantilla, setDatosPlantilla] = useState({
        "urlPlantilla": "",
        "columnas": []
    }
    )
    const queryParams = new URLSearchParams(props.location.search);
    const idCarritoParam = queryParams.get("id");


    useEffect(() => {
        window.scrollTo(0, 0);

        recuperarCarrito(0)
        obtenerExcel()
    }, [])


    /**
    * recupera la información del carrito
    */
    const recuperarCarrito = async (index) => {

        setLoading(true)


        if (idCarritoParam) {
            const resultado = await apiPost2(urlRecuperarCarritoAccP, {
                empresa: empresa,
                idCarrito: idCarritoParam
            })

            if (resultado.transaccion) {
                setCarDescripcionSeguro(resultado.carDescripcionSeguro)

                if (resultado.carDescripcionSeguro == 'AP Segmentos Especiales') {
                    setTituloPrimaNeta('Prima Neta por período')
                    setTituloPrimaTotal('Prima Total por período')
                    setTitulo('AP Segmentos Especiales')
                   
                   
                }

                if (resultado.carDescripcionSeguro == 'ACCIDENTES PERSONALES ABIERTO') {


                    setTituloPrimaNeta('Prima Neta ' + resultado.facturacion.label)
                    setTituloPrimaTotal('Prima Total ' + resultado.facturacion.label)
                    setTitulo('Flexi AP')
                
                }






                setCarritoActual(resultado)
                setTotales(resultado.valorTotal)
                setProductos(resultado.carProductos)
                if (resultado.carProductos[index]) {
                    setProductoSeleccionado(resultado.carProductos[index])


                    if (resultado.carProductos[0].datosPersonas) {

                        setPersonas(resultado.carProductos[index].datosPersonas ? resultado.carProductos[index].datosPersonas : [])
                    }
                }


            }


        }
        setLoading(false)


    }


    /**
      * recupera la información del carrito
      */
    const guardarPersonas = async () => {

        var duplicados = buscarDuplicados()

        if (duplicados.duplicado) {
            setPersonaDuplicadaMasivo(true)
            setIdDuplicadaMasivo(duplicados.id)
        } else {
            setPersonaDuplicadaMasivo(false)
            setIdDuplicadaMasivo('')

            setLoading(true)

            var personasAux = []

            console.log('personasVer', personas)
            personas.forEach(persona => {
                var dateParts = null
                if(persona.fechaNacimiento){

                     dateParts = persona.fechaNacimiento.split("/");

                }else if(persona["FECHA DE NACIMIENTO"]){
                    var dateParts = persona["FECHA DE NACIMIENTO"].split("/");
                }
                var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);


                var auxObject = {
                    fechaNacimiento: moment(dateObject).format("DD/MM/YYYY").trim(),
                    nombre: persona['NOMBRE Y APELLIDO'] ? persona['NOMBRE Y APELLIDO'].trim() : persona['nombre'].trim(),
                    identificacion: persona.IDENTIFICACION ? persona.IDENTIFICACION.toString().trim() : persona.identificacion.toString().trim()
                }


                personasAux.push(auxObject)
            });


            if (idCarritoParam) {

                const body = {
                    "empresa": empresa,
                    "plataforma": "WEB",
                    "ambiente": "Desarrollo",
                    "idCarrito": idCarritoParam,
                    "codigoProductoActual": productoSeleccionado.codigo,
                    "pasoCarrito": "guardarDataPersonas",
                    "datosPersonas": personasAux
                }
                const resultado = await apiPost2(urlGuardarPersonas, body)
                if (resultado.transaccion) {

                    recuperarCarrito(indexProducto)
                    setPersonas(personas)
                    setMostrarErrores(false)
                    setErrorGlobal('')
                    setCalcular(false)
                } else {
                    setMostrarErrores(true)
                    setPersonas(resultado.datosPersonas ? resultado.datosPersonas : personas)
                    if (resultado.errorDescripcion && resultado.errorDescripcion != '') {

                        setErrorGlobal(resultado.errorDescripcion)
                    } else {
                        setErrorGlobal('')
                    }
                }


            }
            setLoading(false)
            window.scrollTo(0, 0);
        }

    }

    /**
     * Ingresar una persona en la lista 
     * @param {*} values datos de la persona a ingresar
     */
    const agregarPersona = (values) => {
        const duplicado = estaDuplicada(values.IDENTIFICACION);
        if (!duplicado) {
            setPersonaDuplicada(false)
            setLoading(true)
            const clonedData = [...personas];

            clonedData.push(values)

            setPersonas(clonedData);

            setCalcular(true)
            setMostrarErrores(false)
            setValues(valuesAux)

            setTimeout(() => {
                setLoading(false)
            }, 1000);
        } else {
            setPersonaDuplicada(true)
        }


    }

    /**
     * Busca duplicados en la lista de personas ingresada
     * @returns true si esta duplicado, caso contrario false
     */
    const buscarDuplicados = () => {



        var aux = false
        var duplicado = ''

        var personasAux = personas.map(p => { return { ...p, IDENTIFICACION: p.identificacion ? p.identificacion : p.IDENTIFICACION } })

        personasAux.forEach(persona => {

            var aux2 = [...personasAux]
            var count = aux2.filter((personal) => personal.IDENTIFICACION == persona.IDENTIFICACION).length
            if (count > 1) {
                aux = true
                duplicado = persona.IDENTIFICACION

            } else {
                var lista = [...productos]
                var listaFiltrada = lista.filter((elemento) => elemento.codigo != productoSeleccionado.codigo)

                listaFiltrada.forEach(producto => {
                    if (producto && producto.datosPersonas) {
                        var aux2 = [...producto.datosPersonas]
                        var count = aux2.filter((personal) => personal.IDENTIFICACION == persona.IDENTIFICACION).length
                        if (count > 0) {
                            aux = true
                            duplicado = persona.IDENTIFICACION

                        }
                    }
                });
            }

        });



        return {
            duplicado: aux,
            id: duplicado
        }
    }

    /**
     * 
     * @param {*} identificacion Número de identificación
     * @returns true si esta duplicado, caso contrario false
     */
    const estaDuplicada = (identificacion) => {

        console.log('identificacion', identificacion)
        const personaEncontrada = personas.find(persona => persona.IDENTIFICACION == identificacion)

        if (!personaEncontrada) {
            var estaEnLista = false

            productos.forEach(producto => {
                if (producto.datosPersonas) {
                    const personaEncontradaAux = producto.datosPersonas.find(persona => persona.IDENTIFICACION == identificacion)
                    if (personaEncontradaAux) {
                        estaEnLista = true
                    }
                }


            });

            return estaEnLista

        } else {
            return true
        }




    }

    /**
     * 
     * @param {*} ruc Ruc de la persona
     * @param {*} values  Valores a modificar
     * @param {*} tipo tipo de documento de identificación
     */
    const consultarRuc = async (ruc, values, tipo) => {

        setLoading(true)
        const resultado = await apiPost2(urlConsultarIdentificacion, {
            "empresa": empresa,
            "identificador": ruc,
            "tipo": tipo
        })

        if (resultado.transaccion) {
            var objeto = { ...values }
            objeto['nombre'] = resultado.datosIdentificador[0]['nombre'];
            objeto['fechaNacimiento'] = resultado.datosIdentificador[0]['fechNacimiento'];
            setValues(objeto)
        }
        window.scrollTo(0, 0);
        setLoading(false)
    }

    const obtenerExcel = async () => {

        setLoading(true)


        if (idCarritoParam) {
            const resultado = await apiGet(urlObtenerExcel + 'ap_abierto')

            if (resultado.transaccion) {
                setDatosPlantilla(resultado)
            }


        }
        setLoading(false)


    }

    return (
        <LoadingScreen
            loading={loading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Cargando..."
        >

            <ContainerApAbierto
                paso={'confirmacion'}
                titulo={titulo}
            >

                <Row>
                    <Col sm={12} md={12} lg={8}>


                        <ComponentOpciones

                            productos={productos}
                            productoSeleccionado={productoSeleccionado}
                            indexProducto={indexProducto}
                            setIndexProducto={(valor) => { setIndexProducto(valor) }}
                            setProductoSeleccionado={(valor, index) => {
                                setLoading(true)
                                setProductoSeleccionado(valor)
                                window.scrollTo(0, 0);

                                recuperarCarrito(index)
                                setTimeout(() => {
                                    setLoading(false)
                                }, 1500);
                            }}


                        />
                        {productoSeleccionado &&
                            <ComponentTipoCarga
                                value={value}
                                productoSeleccionado={productoSeleccionado}
                                setValue={(value) => {
                                    return setValue(value)
                                }}
                            />
                        }

                        {productoSeleccionado && value && value == "manual" &&
                            <div>
                                <Formulario
                                    setLoading={(value) => setLoading(value)}
                                    codigoFormulario={'formulario-busca-personas'}
                                    onSubmit={async (values, tieneErrores, errores) => {
                                        if (!tieneErrores) {
                                            agregarPersona({
                                                IDENTIFICACION: values.identificacion,
                                                'NOMBRE Y APELLIDO': values.nombre,
                                                fechaNacimiento: values.fechaNacimiento
                                            })



                                        }
                                    }}
                                    values={values}

                                    onChange={(key, values) => {
                                        setValues(values)

                                        if (key == 'identificacion') {
                                            if (values.identificacion && values.identificacion.length == 13) {
                                                consultarRuc(values.identificacion, values, 'ruc', 'nombreEmpresa', 'nombre')
                                            }
                                        }

                                        if (key == 'identificacion') {
                                            if (values.identificacion && values.identificacion.length == 10) {
                                                consultarRuc(values.identificacion, values, 'cedula', 'nombreSolicitante', 'nombre')
                                            }
                                        }


                                    }}

                                    setValuesInicial={(values) => {




                                        setValues(values)
                                        setValuesAux(values)


                                    }}
                                />

                                <Alert
                                    color="danger"
                                    isOpen={personaDuplicada}

                                >
                                    <center>
                                        <p>
                                            La persona ingresada ya forma parte de la lista de personas, por favor revise los datos
                                        </p>
                                    </center>
                                </Alert>

                            </div>
                        }

                        {productoSeleccionado && value && value == "masiva" &&
                            <ComponentCargaMasiva
                                datosPlantilla={datosPlantilla}
                                setDatos={(datos) => {
                                    setPersonas(datos)
                                    setCalcular(true)
                                }}
                                plantillaConError={plantillaConError}
                                setPlantillaConError={(valor) => { setPlantillaConError(valor) }}
                                setColumnas={(datos) => setColumnas(datos)}
                            />
                        }


                        <ComponentPersonas
                            personas={personas}
                            cerrado={false}
                            mostrarErrores={mostrarErrores}
                            estaDuplicada={estaDuplicada}
                            setPersonas={(valor) => {
                                setCalcular(true)
                                setPersonas(valor)
                            }}
                        />

                        <Card>
                            <CardBody>
                                <Button
                                    onClick={() => {

                                        if (carDescripcionSeguro == 'AP Segmentos Especiales') {
                                            props.history.push({
                                                pathname: "/cotizacion-accidente-personal-corto-plazo-resumen",
                                                search: `?id=${idCarritoParam}`, //agregar parametros de la url,
                                            });
                                           
                                        }
                        
                                        if (carDescripcionSeguro == 'ACCIDENTES PERSONALES ABIERTO') {
                        
                        
                                            props.history.push({
                                                pathname: "/cotizacion-accidente-personal-abierto-resumen",
                                                search: `?id=${idCarritoParam}`, //agregar parametros de la url,
                                            });
                                        }
                                       
                                    }}
                                    className="btn btn-purple btn btn-secondary"
                                    style={{ marginLeft: "5px" }}
                                >
                                    <i class="fa fa-chevron-circle-left" aria-hidden="true" />
                                    &nbsp;REGRESAR
                                </Button>
                            </CardBody>
                        </Card>


                    </Col>
                    <Col sm={12} md={12} lg={4}>

                        {totales &&
                            <Valores
                                totales={totales}
                                paso={'cargaVidas'}
                                history={props.history}
                                loading={loading}
                                setLoading={(valor) => { setLoading(valor) }}
                                idCarrito={idCarritoParam}
                                urlPdf={urlPdf}
                                calcular={calcular}
                                guardarPersonas={() => {
                                    guardarPersonas()
                                }}
                                productos={productos}
                                personaDuplicadaMasivo={personaDuplicadaMasivo}
                                errorGlobal={errorGlobal}
                                idDuplicadaMasivo={idDuplicadaMasivo}
                                tituloPrimaNeta={tituloPrimaNeta}
                                tituloPrimaTotal={tituloPrimaTotal}
                            />
                        }

                    </Col>
                </Row>

            </ContainerApAbierto>

        </LoadingScreen>

    )

}

export default ContainerCargaVidas